/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { FontFamily, FontFamilyFromJSON, FontFamilyFromJSONTyped, FontFamilyToJSON } from './FontFamily'
import { TextAlignment, TextAlignmentFromJSON, TextAlignmentFromJSONTyped, TextAlignmentToJSON } from './TextAlignment'

/**
 *
 * @export
 * @interface UpdateSiteSectionRequestSiteSection
 */
export interface UpdateSiteSectionRequestSiteSection {
  /**
   *
   * @type {string}
   * @memberof UpdateSiteSectionRequestSiteSection
   */
  name?: string
  /**
   *
   * @type {TextAlignment}
   * @memberof UpdateSiteSectionRequestSiteSection
   */
  titleAlignment?: TextAlignment
  /**
   *
   * @type {FontFamily}
   * @memberof UpdateSiteSectionRequestSiteSection
   */
  titleFontFamily?: FontFamily
  /**
   * タイトル文字サイズ (10-72)
   * @type {number}
   * @memberof UpdateSiteSectionRequestSiteSection
   */
  titleFontSize?: number
  /**
   * 16進数カラーコード (#XXXXXX形式または#XXX短縮形式)
   * @type {string}
   * @memberof UpdateSiteSectionRequestSiteSection
   */
  titleTextColor?: string
}

export function UpdateSiteSectionRequestSiteSectionFromJSON(json: any): UpdateSiteSectionRequestSiteSection {
  return UpdateSiteSectionRequestSiteSectionFromJSONTyped(json, false)
}

export function UpdateSiteSectionRequestSiteSectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSiteSectionRequestSiteSection {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    titleAlignment: !exists(json, 'title_alignment') ? undefined : TextAlignmentFromJSON(json['title_alignment']),
    titleFontFamily: !exists(json, 'title_font_family') ? undefined : FontFamilyFromJSON(json['title_font_family']),
    titleFontSize: !exists(json, 'title_font_size') ? undefined : json['title_font_size'],
    titleTextColor: !exists(json, 'title_text_color') ? undefined : json['title_text_color']
  }
}

export function UpdateSiteSectionRequestSiteSectionToJSON(value?: UpdateSiteSectionRequestSiteSection | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    title_alignment: TextAlignmentToJSON(value.titleAlignment),
    title_font_family: FontFamilyToJSON(value.titleFontFamily),
    title_font_size: value.titleFontSize,
    title_text_color: value.titleTextColor
  }
}
